import { IStore } from 'src/interfaces/store';
import { StoreExtractor } from './types';

export class StoreNameExtractor implements StoreExtractor<string> {
    extract(store: IStore): string {
        return store.make.name;
    }

    shouldInclude(): boolean {
        return true;
    }
}
